const NO_SHOW_UI_SCHEMA = {
  summary: {
    items: [
      {
        label: 'Scheduled shifts',
        property: 'shiftsCount',
        formula: 'data.scheduledCount || 0',
        unit: 'none',
      },
      {
        label: 'Actual shifts',
        property: 'actualShiftsCount',
        formula: 'data.actualCount || 0',
        unit: 'none',
      },
      {
        label: 'Scheduled hours',
        property: 'hours',
        formula: 'data.scheduledMinutes || 0',
        unit: 'minutes',
      },
      {
        label: 'Actual hours',
        property: 'actualHours',
        formula: 'data.actualMinutes || 0',
        unit: 'minutes',
      },
      {
        label: 'No show',
        property: 'noShow',
        formula: 'data.noShow || 0',
        unit: 'none',
      },
      {
        label: 'Sick callout',
        property: 'sickCallout',
        formula: 'data.sickCallout || 0',
        unit: 'none',
      },
      {
        label: 'Late arrivals',
        property: 'lateArrivals',
        formula: 'data.lateCount || 0',
        unit: 'none',
        if: 'orgSettings.lateArrivalEnabled',
      },
    ],
  },
  table: {
    columnSections: [
      {
        key: 'details',
        title: 'Details',
      },
      {
        key: 'hoursAndShifts',
        title: 'Hours&Shifts',
      },
      {
        key: 'status',
        title: 'Status',
      },
    ],
    items: [
      {
        property: 'fullLegalName',
        columnDescription: 'Legal name',
        columnHeader: 'legal name',
        activeByDefault: false,
        formula: 'data.user.fullLegalName',
        unit: 'none',
        sectionKey: 'details',
      },
      {
        property: 'employeeId',
        columnDescription: 'Employee ID',
        columnHeader: 'employee id',
        activeByDefault: false,
        formula: 'data.user.employeeId',
        userLink: 'data.user.id',
        unit: 'none',
        sumUp: false,
        groupTotal: true,
        emptyValue: "'-'",
        includeForTotals: false,
        sectionKey: 'details',
      },
      {
        property: 'location',
        columnDescription: 'Location',
        columnHeader: 'location',
        activeByDefault: true,
        detailsIndicator: true,
        formula: 'data.location',
        linkedLocation: true,
        sumUp: false,
        if: '!options.showReportsAsTotals && options.sortBy !== "location"',
        unit: 'none',
        includeForTotals: false,
        sectionKey: 'details',
      },
      {
        property: 'locationExternalId',
        columnDescription: 'Location ID',
        columnHeader: 'location id',
        activeByDefault: false,
        detailsIndicator: true,
        sumUp: false,
        formula: 'data.location.externalId',
        locationLink: 'data.location.id',
        unit: 'none',
        if: '!options.showReportsAsTotals && options.sortBy !== "location"',
        emptyValue: "'-'",
        includeForTotals: false,
        sectionKey: 'details',
      },
      {
        property: 'position',
        columnDescription: 'Position',
        columnHeader: 'position',
        activeByDefault: true,
        detailsIndicator: true,
        formula: 'data.position',
        sumUp: false,
        unit: 'none',
        emptyValue: "'-'",
        if: '!options.showReportsAsTotals && options.sortBy !== "position"',
        linkedPosition: true,
        includeForTotals: false,
        sectionKey: 'details',
      },
      {
        property: 'positionExternalId',
        columnDescription: 'Position ID',
        columnHeader: 'position id',
        activeByDefault: false,
        detailsIndicator: true,
        sumUp: false,
        formula: 'data.position.externalId',
        positionLink: 'data.position.id',
        unit: 'none',
        if: '!options.showReportsAsTotals && options.sortBy !== "position"',
        emptyValue: "'-'",
        includeForTotals: false,
        sectionKey: 'details',
      },
      {
        property: 'groups',
        columnDescription: 'Groups',
        columnHeader: 'groups',
        activeByDefault: false,
        detailsIndicator: true,
        formula: 'data.user.groups',
        sumUp: false,
        unit: 'none',
        emptyValue: "'-'",
        if: '!options.showReportsAsTotals && options.sortBy !== "group" && !!options.groups.length',
        linkedGroup: true,
        includeForTotals: false,
        sectionKey: 'details',
      },
      {
        property: 'scheduledCount',
        columnDescription: 'Scheduled shifts',
        columnHeader: 'sch. shifts',
        activeByDefault: true,
        formula: 'data.scheduled || 0',
        calculateOnAggregated: false,
        sumUp: true,
        unit: 'none',
        emptyValue: '0',
        includeForTotals: true,
        sectionKey: 'hoursAndShifts',
      },
      {
        property: 'scheduledMinutes',
        columnDescription: 'Scheduled hours',
        columnHeader: 'sch. hours',
        activeByDefault: true,
        formula: 'data.scheduledMinutes || 0',
        sumUp: true,
        calculateOnAggregated: false,
        unit: 'minutes',
        emptyValue: "options.showDurationsAsDecimals ? '0' : '0h'",
        includeForTotals: true,
        sectionKey: 'hoursAndShifts',
      },
      {
        property: 'actualCount',
        columnDescription: 'Actual shifts',
        columnHeader: 'act. shifts',
        activeByDefault: true,
        formula: 'data.actual || 0',
        calculateOnAggregated: false,
        sumUp: true,
        unit: 'none',
        emptyValue: '0',
        includeForTotals: true,
        sectionKey: 'hoursAndShifts',
      },
      {
        property: 'actualMinutes',
        columnDescription: 'Actual hours',
        columnHeader: 'act. hours',
        activeByDefault: true,
        formula: 'data.actualMinutes || 0',
        sumUp: true,
        calculateOnAggregated: false,
        unit: 'minutes',
        emptyValue: "options.showDurationsAsDecimals ? '0' : '0h'",
        includeForTotals: true,
        sectionKey: 'hoursAndShifts',
      },
      {
        property: 'noShow',
        columnDescription: 'No show',
        columnHeader: 'no show',
        activeByDefault: true,
        sumUp: true,
        formula: 'data.noShow || 0',
        calculateOnAggregated: false,
        unit: 'none',
        emptyValue: "'0'",
        includeForTotals: true,
        sectionKey: 'status',
      },
      {
        property: 'sickCallout',
        columnDescription: 'Sick callout',
        columnHeader: 'sick callout',
        activeByDefault: true,
        sumUp: true,
        formula: 'data.sickCallout || 0',
        calculateOnAggregated: false,
        unit: 'none',
        disabledDescription:
          'Timeclock needs to be enabled for this column. Enable it in settings.',
        emptyValue: "'0'",
        includeForTotals: true,
        sectionKey: 'status',
      },
      {
        property: 'lateArrivals',
        columnDescription: 'Late arrivals',
        columnHeader: 'late arrivals',
        activeByDefault: true,
        sumUp: true,
        formula: 'data.lateCount || 0',
        calculateOnAggregated: false,
        unit: 'none',
        disabledDescription:
          'Timeclock and late arrival tracking need to be enabled for this column. Enable them in settings.',
        emptyValue: "'0'",
        includeForTotals: true,
        if: 'orgSettings.lateArrivalEnabled',
        sectionKey: 'status',
      },
    ],
  },
};

export default NO_SHOW_UI_SCHEMA;
